

import React, { useEffect, useState } from "react"
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Image,
  Alert,
  User,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

import { linksUrl } from "../constants/enum.js"
import { setLogin } from "../state/authSlice.jsx"
import { usePostLogin } from "../api/reactQueryCustomHooks.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { resetCompCode } from "../state/companySlice.jsx"
import { isMobile } from "react-device-detect"


export default function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)


  const [formData, setFormData] = useState({
    clientCode: "",
    loginName: "",
    password: "",
  })

  const [errors, setErrors] = useState({})

  const resetValues = () => {
    setFormData({
      clientCode: "",
      loginName: "",
      password: "",
    })
  }

  const onSuccessTasks = (data) => {

    if (data && Object.keys(data)?.length > 0) {

      navigate(linksUrl.companies)
      dispatch(
        setLogin({
          user: data.user,
          token: data.accessToken,
          menu: { appMenu: data.appMenu, userMenu: data.userMenu },
          isAuthenticated: true,
          userSetting: data.userSetting
        })
      )
      dispatch(resetCompCode())
      queryClient.removeQueries()
    }
    else {
      toast.error("Incorrect Details...", {
        "position": "top-center"
      })
    }


  }

  const { isPending, mutate: login } = usePostLogin({
    url: "/user/login",
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    let msg = ''
    if (formData.clientCode.trim() === "") {
      msg = " Client Code required , "
    }
    if (formData.loginName.trim() === "") {
      msg += " Login Name required , "
    }
    if (formData.password.trim() === "") {
      msg += " Password required , "
    }
    return msg
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    let errorMsg = validateForm()


    if (errorMsg.trim() == "") {
      login({
        data: {
          Client_Code: formData.clientCode,
          LoginName: formData.loginName,
          Password: formData.password,
        },
      })
    }
    else {
      toast.error(errorMsg, { "position": "top-center" })
    }

  }

  return (

    <div className="min-h-screen bg-slate-50">
      <ToastContainer />

      {/* Header */}

   
<header className="relative z-10 flex h-14 items-center justify-between border-b border-white/10 
bg-gradient-to-r from-sky-950 via-sky-60 to-sky-700 px-4 shadow-lg sm:px-6">

  {/* Left: Company Branding */}
  <div className="flex items-center gap-3">

    {/* Company Logo */}
    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 p-1.5 ring-1 ring-white/15">
      <img
        src="IITS_Logo.png"
        alt="IITS Logo"
        className="h-full w-full object-contain"
      />
    </div>

    {/* Divider */}
    <div className="h-8 w-px bg-white/20" />

    {/* Application Name */}
    <div className="flex flex-col justify-center">
      <span className="text-lg font-extrabold leading-tight tracking-[0.18em] text-white">
        WINAPP
      </span>
      <span className="mt-0.5 text-[9px] font-medium uppercase tracking-[0.2em] text-sky-200">
        Textile Management
      </span>
    </div>

  </div>

  {/* Right: Textile Icon */}
  {/* <div className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-white/10">
    <img
      src="/textile-icon.png"
      alt="Textile industry"
      className="h-6 w-6 object-contain"
    />
  </div> */}

</header>

      {/* Main Content */}
      <main className="relative flex min-h-[calc(100vh-4rem)] items-center justify-center overflow-hidden px-4 py-10 sm:px-6 lg:px-8">

        {/* Background decoration */}
        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-sky-200/40 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-blue-200/40 blur-3xl" />

        {/* Login Card */}

        <section className="relative w-full max-w-md overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-xl shadow-slate-200/70">

          {/* Top Accent */}
          <div className="h-1 w-full bg-gradient-to-r from-sky-500 via-blue-600 to-indigo-600" />

          <div className="px-5 py-5 sm:px-8 sm:py-6">

            {/* Logo and Welcome - Single Row */}
            <div className="mb-10 flex items-center gap-3">

              {/* Company Logo */}
              <div className="flex h-12 w-12 shrink-0  bg-b-50 items-center justify-center">
                <img
                  src="text_icon.png"
                  alt="WINAPP company logo"
                  className="h-full w-full object-contain"
                />
              </div>

              {/* Welcome Text */}
              <div className="min-w-0 flex-1">
                <h1 className="text-md font-bold tracking-tight text-slate-900">
                  Welcome to WINAPP
                </h1>

                <p className="mt-1 text-xs leading-5 text-slate-500 sm:text-sm">
                  Please sign in to access your account.
                </p>
              </div>

            </div>

            {/* Login Form */}
            <form
              onSubmit={handleSubmit}
              autoComplete="off"
              className="space-y-8"
            >

              {/* Client Code */}
              <Input
                isRequired
                type="text"
                label="Client Code"
                placeholder="Enter your client code"
                labelPlacement="outside"
                name="clientCode"
                value={formData.clientCode}
                onChange={handleChange}
                variant="bordered"
                radius="lg"
                size="lg"
                isDisabled={isPending}
                classNames={{
                  base: "w-full",
                  label: "mb-2 text-sm font-semibold text-slate-700",
                  inputWrapper:
                    "border-slate-200 bg-slate-50 shadow-none hover:border-sky-400 group-data-[focus=true]:border-sky-600",
                  input: "text-sm text-slate-800",
                }}
              />

              {/* Login Name */}
              <Input
                isRequired
                type="text"
                label="Login Name"
                placeholder="Enter your login name"
                labelPlacement="outside"
                name="loginName"
                value={formData.loginName}
                onChange={handleChange}
                variant="bordered"
                radius="lg"
                size="lg"
                isDisabled={isPending}
                classNames={{
                  base: "w-full",
                  label: "mb-1.5  text-sm font-semibold text-slate-700",
                  inputWrapper:
                    "border-slate-200 bg-slate-50 shadow-none hover:border-sky-400 group-data-[focus=true]:border-sky-600",
                  input: "text-sm text-slate-800",
                }}
              />

              {/* Password */}
              <Input
                isRequired
                label="Password"
                labelPlacement="outside"
                placeholder="Enter your password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                isDisabled={isPending}
                variant="bordered"
                radius="lg"
                size="lg"
                type={isVisible ? "text" : "password"}
                classNames={{
                  base: "w-full",
                  label: "mb-1.5  text-sm font-semibold text-slate-700",
                  inputWrapper:
                    "border-slate-200 bg-slate-50 shadow-none hover:border-sky-400 group-data-[focus=true]:border-sky-600",
                  input: "text-sm text-slate-800",
                }}
                endContent={
                  <button
                    type="button"
                    onClick={toggleVisibility}
                    disabled={isPending}
                    aria-label={
                      isVisible ? "Hide password" : "Show password"
                    }
                    className="rounded-md p-1 text-slate-400 transition-colors hover:text-sky-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500"
                  >
                    <FontAwesomeIcon
                      icon={isVisible ? faEyeSlash : faEye}
                    />
                  </button>
                }
              />

              {/* Login Button */}
              <div className="pt-2">
                <Button
                  type="submit"
                  color="primary"
                  isLoading={isPending}
                  isDisabled={isPending}
                  radius="lg"
                  size="lg"
                  className="h-10 w-full bg-gradient-to-r from-sky-700 to-blue-700 text-sm font-semibold uppercase tracking-[0.15em] text-white shadow-md shadow-sky-900/15 transition-all duration-200 hover:from-sky-800 hover:to-blue-800 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2"
                >
                  Login
                </Button>
              </div>

            </form>

            {/* Footer */}
            <div className="mt-5 border-t border-slate-100 pt-4 text-center">
              <p className="text-xs tracking-wide text-slate-400">
                Secure access to your workspace
              </p>
            </div>

          </div>
        </section>
      </main>
    </div>

  )
}
